import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import forge from "node-forge";

@Injectable({
  providedIn: 'root'
})
export class EncrptionService {

  constructor() { }

  // Generate a 32-byte AES key
  generateAESKey(): string {
    return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Base64);
  }

  // Encrypt phone number using AES-256
  encryptPhoneNumber(phoneNumber: string, aesKey: string): { encryptedPhone: string, encryptedAESKey: string } {
    const key = CryptoJS.enc.Base64.parse(aesKey);  // Convert AES Key from Base64
    const iv = CryptoJS.lib.WordArray.random(16);  // Generate IV

    const encrypted = CryptoJS.AES.encrypt(phoneNumber, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Combine IV and encrypted text in Base64 format
    const encryptedPhone = iv.toString(CryptoJS.enc.Hex) + ":" + encrypted.toString();

    return { encryptedPhone, encryptedAESKey: aesKey };
  }

  // Encrypt AES key using RSA
  encryptAESKeyWithRSA(aesKey: string, publicKeyString: string): string {
    const publicKey = forge.pki.publicKeyFromPem(publicKeyString);
    return forge.util.encode64(publicKey.encrypt(aesKey, "RSA-OAEP"));
  }

  // Main function to encrypt phone number & AES key
  encryptPhoneWithRSA_AES(phoneNumber: string, publicKeyString: string) {
    const aesKey = this.generateAESKey(); // Step 1: Generate AES Key
    const { encryptedPhone, encryptedAESKey } = this.encryptPhoneNumber(phoneNumber, aesKey); // Step 2: AES Encrypt
    const encryptedRSAKey = this.encryptAESKeyWithRSA(encryptedAESKey, publicKeyString); // Step 3: Encrypt AES Key with RSA

    return {
      encryptedPhone,
      encryptedRSAKey
    };
  } 

}
